// extracted by mini-css-extract-plugin
export default {"root":"TextButton_root__wTmxw","small":"TextButton_small__+tRNg","extraSmall":"TextButton_extraSmall__UJjbk"};